import api from '@/lib/axios';
import type {
  CustomerCategoryResponse,
  CustomerCategoryTreeResponse,
  CustomerCategoryDetailResponse,
} from '@/types';

/**
 * Get flat list of categories with equipment counts
 */
export const getCategories = async (locationId?: string): Promise<CustomerCategoryResponse[]> => {
  const params = locationId ? { locationId } : {};
  const response = await api.get<CustomerCategoryResponse[]>('/customer/categories', { params });
  return response.data;
};

/**
 * Get hierarchical category tree with equipment counts
 */
export const getCategoryTree = async (locationId?: string): Promise<CustomerCategoryTreeResponse[]> => {
  const params = locationId ? { locationId } : {};
  const response = await api.get<CustomerCategoryTreeResponse[]>('/customer/categories/tree', { params });
  return response.data;
};

/**
 * Get featured categories for homepage display
 */
export const getFeaturedCategories = async (
  locationId?: string,
  limit: number = 6
): Promise<CustomerCategoryResponse[]> => {
  const params = { locationId, limit };
  const response = await api.get<CustomerCategoryResponse[]>('/customer/categories/featured', { params });
  return response.data;
};

/**
 * Get category detail by slug with breadcrumb and subcategories
 */
export const getCategoryBySlug = async (
  slug: string,
  locationId?: string
): Promise<CustomerCategoryDetailResponse> => {
  const params = locationId ? { locationId } : {};
  const response = await api.get<CustomerCategoryDetailResponse>(`/customer/categories/by-slug/${slug}`, { params });
  return response.data;
};

/**
 * Get related categories
 */
export const getRelatedCategories = async (
  categoryId: string,
  locationId?: string,
  limit: number = 4
): Promise<CustomerCategoryResponse[]> => {
  const params = { locationId, limit };
  const response = await api.get<CustomerCategoryResponse[]>(`/customer/categories/${categoryId}/related`, { params });
  return response.data;
};
